/**
 * vue component (push handler) >> push methods >> push service >> vuex
 */
import vuexStore from '@/vuex-store';
import { fulfillmentPushService } from './fulfillmentPushService';
const { state } = vuexStore;
export const fulfillmentPushMethod = {
    /**
     * 출근
     * @param payload
     */
    event_worker_on({ pushData, }) {
        fulfillmentPushService.addWorker(pushData);
    },
    /**
     * 배차
     * @param payload
     */
    event_worker_allocated({ pushData, code, }) {
        fulfillmentPushService.updateWorker(pushData, code);
    },
    /**
     * 휴식
     * @param payload
     */
    event_worker_rest({ pushData, code, }) {
        fulfillmentPushService.updateWorker(pushData, code);
    },
    /**
     * 운행
     * @param payload
     */
    event_worker_driving({ pushData, code, }) {
        const { allocateCancelIds } = pushData;
        const worker = state.listControl.workerList[code];
        if (worker) {
            fulfillmentPushService.updateWorker(pushData, code);
        }
        else {
            fulfillmentPushService.addWorker(pushData);
        }
        // 선택된 라이더의 푸시일 때만 마커 로직 실행
        if (code === state.listControl.selectedWorker?.user?.code) {
            fulfillmentPushService.clearWorkerOrderMarkers(allocateCancelIds);
            pushData.truncateAllocateCancelIds();
        }
    },
    /**
     * 대기
     * @param payload
     */
    event_worker_waiting({ pushData, code, }) {
        const worker = state.listControl.workerList[code];
        if (worker) {
            fulfillmentPushService.updateWorker(pushData, code);
        }
        else {
            fulfillmentPushService.addWorker(pushData);
        }
    },
    /**
     * 퇴근
     * @param payload
     * @returns
     */
    event_worker_off({ pushData, code, }) {
        fulfillmentPushService.offWorker(pushData, code);
    },
    /**
     * 대기중인 공유 라이더 제거
     * @param pushData
     * @param workerCode
     */
    deleteWaitingShareWorker(pushData, workerCode) {
        pushData.isWaitingShareWorker && fulfillmentPushService.deleteWorker(workerCode);
    },
};
